import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { Link } from "react-router-dom";

import applyOnlineImg from "../assets/home/Apply.svg";
import getApprovedImg from "../assets/home/approved.svg";
import receiveLoanImg from "../assets/home/money.svg";
import uploadDocumentImg from "../assets/home/Upload.svg";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div
      className={className}
      style={{
        ...style,
        right: isMobile ? "15px" : "25px",
        zIndex: 1,
        color: "red",
        cursor: "pointer",
        pointerEvents: className?.includes("slick-disabled") ? "none" : "auto",
        fontSize: isMobile ? "20px" : "inherit",
        top: "40%",
        transform: "translateY(-50%)",
        display: isMobile ? "none" : style?.display,
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div
      className={className}
      style={{
        ...style,
        left: isMobile ? "15px" : "25px",
        zIndex: 1,
        color: "red",
        cursor: "pointer",
        pointerEvents: className?.includes("slick-disabled") ? "none" : "auto",
        fontSize: isMobile ? "20px" : "inherit",
        top: "40%",
        transform: "translateY(-50%)",
        display: isMobile ? "none" : style?.display,
      }}
      onClick={onClick}
    />
  );
}

const HomePageSlider = ({ imagesHero }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const settings = {
    dots: isMobile,
    infinite: true,
    speed: 500,
    zIndex: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: !isMobile,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    adaptiveHeight: false,

    customPaging: (i) => (
      <div
        style={{
          width: isMobile ? "8px" : "12px",
          height: isMobile ? "8px" : "12px",
          zIndex: 1,
          borderRadius: "50%",
          backgroundColor: i ? "rgba(255,255,255,0.5)" : "#0265fe",
          margin: isMobile ? "6px 0" : "8px 0",
          border: "1px solid #fff",
        }}
      />
    ),
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .slick-prev:before, .slick-next:before {
        color: #00cc87 !important;
        opacity: 1 !important;
        z-index: 1 !important;
        line-height: 5 !important;
        font-size: ${isMobile ? "20px" : "24px"} !important;
        display: ${isMobile ? "none" : "block"} !important;
      }
      
      .slick-prev, .slick-next {
        width: ${isMobile ? "30px" : "40px"} !important;
        height: ${isMobile ? "30px" : "40px"} !important;
      }
      
      .slick-slide {
        height: auto !important;
      }
      
      .slick-track {
        display: flex !important;
        align-items: stretch !important;
      }
      
      .slick-list {
        overflow: hidden;
      }

      .slick-dots {
        bottom: -28px !important;
        z-index: 10 !important;
      }

      .slick-dots li {
        margin: 0 3px !important;
        width: 10px !important;
        height: 10px !important;
      }

      .slick-dots li button:before {
        font-size: 8px !important;
        color: #0265fe !important;
        opacity: 0.35 !important;
      }

      .slick-dots li.slick-active button:before {
        color: #0265fe !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, [isMobile]);

  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 3,
        width: "100%",
        mt: { xs: 2, sm: 2.5, md: 0 },
        pb: { xs: 1, md: 0 },
      }}
    >
      <Slider {...settings}>
        {imagesHero.map((image, index) => (
          <Box key={index} sx={{ height: "100%" }}>
            {/* Desktop Layout */}
            <Box sx={{ display: { xs: "none", md: "block" }, height: "100%" }}>
              <Box
                sx={{
                  backgroundImage: `url(${image?.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundColor: "#fff",
                  height: "65vh",
                  zIndex: 3,
                  width: "100%",
                  position: "relative",
                }}
              >
                <Container maxWidth="lg" sx={{ height: "100%" }}>
                  {(image?.title1 || image?.title2) && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        px: { md: 6, lg: 10 },
                      }}
                    >
                      <Box sx={{ maxWidth: "620px", textAlign: "left", ml: "100px" }}>
                        {/* title1 — blue */}
                        <Typography
                          component="h1"
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: { md: "2rem", lg: "2.6rem" },
                            fontWeight: 700,
                            color: "#0265fe",
                            lineHeight: 1.2,
                            mb: 0,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {image.title1}
                        </Typography>

                        {/* title2 — black, next line */}
                        <Typography
                          component="h2"
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: { md: "2rem", lg: "2.6rem" },
                            fontWeight: 700,
                            color: "#111",
                            lineHeight: 1.2,
                            mb: 1.5,
                          }}
                        >
                          {image.title2}
                        </Typography>

                        {/* description — small gray */}
                        {image?.discription && (
                          <Typography
                            sx={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "18px",
                              fontWeight: 400,
                              color: "#444",
                              lineHeight: 1.6,
                              mb: 3,
                              maxWidth: "580px",
                            }}
                          >
                            {image.discription}
                          </Typography>
                        )}

                        {/* Apply Now button */}
                        <Link to={image?.path || "/"} style={{ textDecoration: "none" }}>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#00cc87",
                              color: "#fff",
                              fontFamily: "Inter, sans-serif",
                              fontWeight: 700,
                              fontSize: "15px",
                              textTransform: "none",
                              px: 4,
                              py: 1.2,
                              borderRadius: "8px",
                              boxShadow: "none",
                              "&:hover": {
                                backgroundColor: "#00b377",
                                boxShadow: "none",
                              },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            Apply Now
                          </Button>
                        </Link>
                      </Box>
                    </Box>
                  )}
                </Container>
              </Box>
            </Box>

            {/* Mobile Layout */}
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                flexDirection: "column",
                width: "100%",
                backgroundColor: "#fff",
                pt: { xs: 2.5, sm: 3.5 },
                pb: { xs: 2, sm: 2.5 },
              }}
            >
              <Box
                sx={{
                  px: { xs: 2, sm: 4 },
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* title1 — blue */}
                <Typography
                  component="h1"
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: { xs: "1.45rem", sm: "1.85rem" },
                    fontWeight: 700,
                    color: "#0265fe",
                    lineHeight: 1.25,
                    mb: 0.5,
                  }}
                >
                  {image.title1}
                </Typography>

                {/* title2 — black */}
                <Typography
                  component="h2"
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: { xs: "1.25rem", sm: "1.55rem" },
                    fontWeight: 700,
                    color: "#111",
                    lineHeight: 1.25,
                    mb: 1,
                  }}
                >
                  {image.title2}
                </Typography>

                {/* description */}
                {(image?.discription || image?.description) && (
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: { xs: "13.5px", sm: "15px" },
                      fontWeight: 400,
                      color: "#444",
                      lineHeight: 1.5,
                      mb: 2,
                      maxWidth: "500px",
                    }}
                  >
                    {image.discription || image.description}
                  </Typography>
                )}

                {/* Apply Now button */}
                <Link to={image?.path || "/"} style={{ textDecoration: "none" }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#00cc87",
                      color: "#fff",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      fontSize: "13.5px",
                      textTransform: "none",
                      px: 3.5,
                      py: 0.9,
                      borderRadius: "8px",
                      boxShadow: "0 4px 14px rgba(0, 204, 135, 0.3)",
                      "&:hover": {
                        backgroundColor: "#00b377",
                      },
                      transition: "background-color 0.2s ease",
                      mb: 2,
                    }}
                  >
                    Apply Now
                  </Button>
                </Link>
              </Box>

              {/* Banner Image Container */}
              <Box
                sx={{
                  width: "100%",
                  px: { xs: 2, sm: 3 },
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "540px",
                    height: { xs: "190px", sm: "240px" },
                    backgroundImage: `url(${image?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "12px",
                    boxShadow: "0 4px 18px rgba(0,0,0,0.07)",
                  }}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>

      <Container maxWidth="lg" sx={{ mt: { xs: 3, md: 4 }, mb: 4, position: "relative", zIndex: 10 }}>
        <Box
          sx={{
            display: { xs: "grid", md: "flex" },
            gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(2, 1fr)" },
            flexDirection: { md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: "10px",
            py: 2,
            px: { xs: 1.5, md: 4 },
            gap: { xs: 2, md: 0 },
            boxShadow: "0 2px 14px rgba(0,0,0,0.06)",
          }}
        >
          {/* Item 1 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 1.5 },
              flex: 1,
              justifyContent: "center",
              borderRight: { md: "1px solid #e0e0e0" },
              width: "100%",
              py: { xs: 1, md: 0 },
              px: { xs: 0.5, sm: 1 },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img src={applyOnlineImg} alt="Apply Online" width="50px" height="50px" style={{ objectFit: 'contain' }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '13px', sm: '15px', md: '16px' }, color: '#1a1a1a' }}>
                Apply Online
              </Typography>
            </Box>
          </Box>
          
          {/* Item 2 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 1.5 },
              flex: 1,
              justifyContent: "center",
              borderRight: { md: "1px solid #e0e0e0" },
              width: "100%",
              py: { xs: 1, md: 0 },
              px: { xs: 0.5, sm: 1 },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img src={uploadDocumentImg} alt="Upload Documents" width="50px" height="50px" style={{ objectFit: 'contain' }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '13px', sm: '15px', md: '16px' }, color: '#1a1a1a' }}>
                Upload Documents
              </Typography>
            </Box>
          </Box>

          {/* Item 3 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 1.5 },
              flex: 1,
              justifyContent: "center",
              borderRight: { md: "1px solid #e0e0e0" },
              width: "100%",
              py: { xs: 1, md: 0 },
              px: { xs: 0.5, sm: 1 },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img src={getApprovedImg} alt="Get Approved" width="50px" height="50px" style={{ objectFit: 'contain' }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '13px', sm: '15px', md: '16px' }, color: '#1a1a1a' }}>
                Get Approved
              </Typography>
            </Box>
          </Box>

          {/* Item 4 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 1.5 },
              flex: 1,
              justifyContent: "center",
              width: "100%",
              py: { xs: 1, md: 0 },
              px: { xs: 0.5, sm: 1 },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img src={receiveLoanImg} alt="Receive Your Loan" width="60px" height="60px" style={{ objectFit: 'contain' }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, fontSize: { xs: '13px', sm: '15px', md: '16px' }, color: '#1a1a1a' }}>
                Receive Your Loan
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HomePageSlider;
